import React, { Component } from "react";
import { Route, Switch, Link } from "react-router-dom";
import { connect } from 'react-redux';
import Box from "../Box";
import Chart from "../Chart";
import ListData from "../ListData";
import TableData from "../TableData";
import DatePicker from "../DatePicker";
import MultiSelect from "../MultiSelect";

import LoadingModal from "../LoadingModal";
import "./styles.css";

import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Segment,
  Button,
  Divider,
  Label,
  Table,
  Tab,
  Icon
} from "semantic-ui-react";
import moment from "moment";
import { loadInitialAnalyticsState } from "../../modules/analytics/AnalyticsActions";

const options = [
  {
    value: "all",
    text: "Location",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300
    }
  },
  {
    value: "locone",
    text: "Location One",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300
    }
  },
  {
    value: "loctwo",
    text: "Location Two",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300
    }
  }
];

class KE_Data extends Component {
  onLogout() {
    this.props.authOnLogout();
  }
  constructor(props) {
    super(props);

    this.state = { value: "all" };
  }
  componentWillMount(){


    const { start_date, end_date } = this.props.filters.selectedDate;
    this.props.dispatch((loadInitialAnalyticsState(start_date, end_date)));
  }
  reset() {
    this.setState({ value: undefined });
  }

  setProducts() {
    this.setState({ value: "products" });
  }

  setValue(e, data) {
    this.setState({ value: data.value });
  }

  render() {
    const { value } = this.state;
    const {
      // breakfast,
      // lunch,
      // dinner,
      net_sales,
      avg_sales,
      gross_margin,
      total_orders,
      locations,
      top_items_by_sales,
      lowest_items_by_sales,
      sales_by_store,
      sales_by_category_chart,
      sales_by_category,
      sales_by_sub_category,
      sales_by_day,
      sales_by_hour_chart,
      all_locations_insights,
      avg_order_size,
      avg_order_value,
      top_basket_category,
      gross_sales,
      void_number,
      refunds,
      refunds_number,
      discounts,
      net_taxes,
      total_cogs,
      payment_method_chart,
      refund_chart,
      voids_chart,
      tabs,
      tips,
      service_charges,
      delivery,
      total_collected,
      payment_methods_by_day_chart
    } = this.props;
    console.log("this.props : ", this.props);

    console.log("top_items_by_sales : ", top_items_by_sales);
    const gross_margin_value = {
      header: gross_margin.header,
      value: gross_margin.data_one.value
    };

    const totalOnline = {
      header: "Online Stores",
      value: locations.length
    };

    const barChartTemplate = {
      chart: {
        backgroundColor: "none",
        marginLeft: 45,
        height: 382,
        fontFamily: "Roboto",
        fontWeight: 400,
        spacingTop: 10,
        type: "line",
        style: {
          paddingBottom: 10,
          fontSize: 16
        }
      },
      title: {
        useHTML: true,
        style: {
          color: "#414042",
          fontSize: 16,
          fontWeight: 400,
          fontFamily: "Roboto"
        },
        text: null,
        align: "left",
        x: -5,
        y: 5
      },
      xAxis: {
        categories: [],
        labels: {
          style: {
            fontSize: "8px"
          }
        }
      },
      yAxis: [
        {
          title: {
            text: null
          }
        }
      ],
      legend: {
        itemStyle: {
          fontWeight: "400",
          fontSize: "13px",
          fontFamily: "Roboto",
          color: "#414042"
        }
      },
      labels: {
        items: []
      },
      series: [],
      credits: {
        enabled: false
      }
    };

    const pieChartTemplate = {
      chart: {
        backgroundColor: "none",
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        verticalAlign: "top",
        height: 280,
        color: "#414042"
      },
      title: {
        text: null,
        align: "center",
        verticalAlign: "middle",
        color: "#414042",
        y: 8,
        style: {
          color: "#666874",
          fontSize: 14,
          fontWeight: 400,
          fontFamily: "Roboto"
        }
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        style: {
          fontWeight: 200,
          fontSize: 12
        }
      },
      plotOptions: {
        pie: {
          colors: [
            "#ed561b ",
            "#f58233 ",
            "#ffb91a ",
            "#fff263 ",
            "#3050d6 ",
            "#2f7ed8 ",
            "#4897e5 ",
            "#409b23 ",
            "#50b432 ",
            "#97bf2b ",
            "#b8d649 "
          ],
          dataLabels: {
            enabled: false,
            distance: 100,
            color: "#414042",
            style: {
              fontWeight: "400",
              color: "#414042"
            }
          },
          center: ["50%", "55%"]
        }
      },
      series: [],
      credits: {
        enabled: false
      }
    };

    const salesByStore = JSON.parse(JSON.stringify(barChartTemplate));
    // salesByStore['title']['text'] = 'SALES BY STORE';
    salesByStore["xAxis"]["categories"] = sales_by_store["categories"];
    salesByStore["series"] = sales_by_store["series"];
    const secondary_yAxis = {
      gridLineWidth: 1,
      title: {
        text: null
      },
      opposite: true
    };
    salesByStore["yAxis"].push(secondary_yAxis);

    const refundByDay = JSON.parse(JSON.stringify(barChartTemplate));

    refundByDay["xAxis"]["categories"] = refund_chart["categories"];
    refundByDay["series"] = refund_chart["series"];

    refundByDay["yAxis"].push(secondary_yAxis);

    const voidByDay = JSON.parse(JSON.stringify(barChartTemplate));

    voidByDay["xAxis"]["categories"] = voids_chart["categories"];
    voidByDay["series"] = voids_chart["series"];

    voidByDay["yAxis"].push(secondary_yAxis);

    const paymentMethod = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyDay['title']['text'] = 'SALES BY DAY';
    paymentMethod["xAxis"]["categories"] = payment_method_chart["categories"];
    paymentMethod["series"] = payment_method_chart["series"];



    const salesbyDay = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyDay['title']['text'] = 'SALES BY DAY';
    salesbyDay["xAxis"]["categories"] = sales_by_day["categories"];
    salesbyDay["series"] = sales_by_day["series"];

    const paymentMethodsByDayChart = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyDay['title']['text'] = 'SALES BY DAY';
    paymentMethodsByDayChart["xAxis"]["categories"] = payment_methods_by_day_chart["categories"];
    paymentMethodsByDayChart["series"] = payment_methods_by_day_chart["series"];
    paymentMethodsByDayChart["yAxis"].push(secondary_yAxis);

    const salesbyHour = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyHour['title']['text'] = 'SALES BY HOUR';
    salesbyHour["xAxis"]["categories"] = sales_by_hour_chart["categories"];
    salesbyHour["series"] = sales_by_hour_chart["series"];

    let salesByCategory = { ...pieChartTemplate };
    salesByCategory["title"]["text"] = sales_by_category_chart["title"]["text"];
    salesByCategory["series"] = sales_by_category_chart["series"];

    let marginBystore = { data: { values: [] }, header: "Margin by Store" };
    all_locations_insights.map((item, index) => {
      let value = {
        category: { value: item.name },
        amt_cur: { value: item.gross_margin.data_one.value }
      };
      marginBystore["data"]["values"].push(value);
    });

    const basketSize = {
      header: "BASKET SIZE",
      data: {
        values: [
          {
            category: { value: avg_order_size.header },
            amt_cur: { value: avg_order_size.value }
          },
          {
            category: { value: avg_order_value.header },
            amt_cur: { value: avg_order_value.value },
            currency: "Rs."
          },
          {
            category: { value: top_basket_category.header },
            amt_cur: { value: top_basket_category.value }
          }
        ]
      }
    };
    const saleSummary = {
      header: "SALES SUMMARY",
      data: {
        values: [
          {
            category: { value: gross_sales.header },
            amt_cur: { value: gross_sales.value }
          },
          {
            category: { value: refunds.header },
            amt_cur: { value: refunds.value }
          },
          {
            category: { value: discounts.header },
            amt_cur: { value: discounts.value }
          },
          {
            category: { value: net_sales.header },
            amt_cur: { value: net_sales.value }
          },
          {
            category: { value: net_taxes.header },
            amt_cur: { value: net_taxes.value }
          }
        ]
      }
    };
    net_sales.header = "Total Revenue";
    top_items_by_sales.header = "Top Selling Menu Products";
    lowest_items_by_sales.header = "Low Selling Menu Products";
   

    const formatNum = num => {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    // console.log("tabs", tabs);
    return (
      <div>
          <Grid.Row style={{ float: "right" }}>
          {/* <Grid.Column>
            <MultiSelect />
          </Grid.Column> */}
          <Grid.Column>
            <div style={styles.datePicker}>
              <DatePicker />
            </div>
          </Grid.Column>
        </Grid.Row>
        <div className="innersection">
          <Header style={styles.mainHeadig} as="h3">
            ORDERS OVERVIEW
          </Header>

          <Grid columns={4}>
            <Box componentData={total_orders} />

            {/* <Box

              componentData={{
                header: "Total Orders",
                original_value: total_orders.original_value,
                value: total_orders.value,
                percent: "1"
              }}
            /> */}
            {all_locations_insights.map((item, index) => {
              let data = {
                header: item.name,
                original_value: item.total_orders.original_value,
                value: item.total_orders.value,
              };
              let locationsData = [];
              let obj = {
                header: item.ms.header,
                value: item.ms.value
              }
              locationsData.push(obj)
              obj = {
                header: item.nms.header,
                value: item.nms.value
              }
              locationsData.push(obj)

              obj = {
                header: item.nonke.header,
                value: item.nonke.value
              }
              locationsData.push(obj)
              // console.log('locationsData : ', locationsData)
              return <Box key={index} componentData={data} locationsData={locationsData} />;
            })}

          </Grid>

          <Header style={styles.mainHeadig} as="h3">
            AMOUNT OVERVIEW
          </Header>

          <Grid columns={4}>
            <Box
              componentData={{
                header: "Total Amount",
                value: net_sales.value,
                original_value: net_sales.original_value
              }}
            />
            {all_locations_insights.map((item, index) => {
              let data = {
                header: item.name,
                original_value: item.net_sales.original_value,
                value: item.net_sales.value
              };
              return <Box key={index} componentData={data} />;
            })}
          </Grid>

          <Grid columns={3}>
            <Chart title="SALES BY DAY" data={salesbyDay} />
            <Chart title="PAYMENTS BY DAY" data={paymentMethodsByDayChart} />
            {/* <Chart title="SALES BY HOUR" data={salesbyHour} /> */}
            <Chart title="SALES BY CATEGORY" data={salesByCategory} />
            {/* <ListData componentData={basketSize} /> */}
          </Grid>

          <Grid columns={1}>
            <Table
              className="mainTable alignment"
              fixed
              style={styles.mainTable}
            >
              <Table.Header>
                <Table.Row style={styles.headerRow}>
                  <Table.HeaderCell textAlign="left" style={styles.hederCell}>
                    Sales Summary
                    </Table.HeaderCell>

                  <Table.HeaderCell style={styles.hederCell}>
                    TOTAL
                    </Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                <Table.Row style={styles.tablerow}>
                  <Table.Cell
                    verticalAlign="middle"
                    textAlign="left"
                    style={styles.tableCellfirst}
                  >
                    Gross Sales
                    </Table.Cell>

                  <Table.Cell
                    verticalAlign="middle"
                    className="totalSales"
                    style={styles.tableCell}
                  >
                    {gross_sales ? gross_sales.value : 0}
                  </Table.Cell>
                </Table.Row>

                <Table.Row style={styles.tablerow}>
                  <Table.Cell
                    verticalAlign="middle"
                    textAlign="left"
                    style={styles.tableCellfirst}
                  >
                    Discount & Comps
                    </Table.Cell>


                  <Table.Cell
                    verticalAlign="middle"
                    className="totalSales"
                    style={styles.tableCell}
                  >
                    {discounts ? discounts.value : 0}
                  </Table.Cell>
                </Table.Row>

                <Table.Row style={styles.tablerow}>
                  <Table.Cell
                    verticalAlign="middle"
                    textAlign="left"
                    style={styles.tableCellfirst}
                  >
                    Total Revenue
                    </Table.Cell>

                  <Table.Cell
                    verticalAlign="middle"
                    className="totalSales"
                    style={styles.tableCell}
                  >
                    {net_sales.value}
                  </Table.Cell>
                </Table.Row>

                <Table.Row style={styles.tablerow}>
                  <Table.Cell
                    verticalAlign="middle"
                    textAlign="left"
                    style={styles.tableCellfirst}
                  >
                    COGS
                    </Table.Cell>


                  <Table.Cell
                    verticalAlign="middle"
                    className="totalSales"
                    style={styles.tableCell}
                  >
                    {total_cogs ? total_cogs.value : 0}
                  </Table.Cell>
                </Table.Row>

                <Table.Row style={styles.tablerow}>
                  <Table.Cell
                    verticalAlign="middle"
                    textAlign="left"
                    style={styles.tableCellfirst}
                  >
                    Margin By Rs
                    </Table.Cell>

                  <Table.Cell
                    verticalAlign="middle"
                    className="totalSales"
                    style={styles.tableCell}
                  >
                    Rs. {gross_margin ? gross_margin.data_one.value : 0}
                  </Table.Cell>
                </Table.Row>

                <Table.Row style={styles.tablerow}>
                  <Table.Cell
                    verticalAlign="middle"
                    textAlign="left"
                    style={styles.tableCellfirst}
                  >
                    Margin By %
                    </Table.Cell>


                  <Table.Cell
                    verticalAlign="middle"
                    className="totalSales"
                    style={styles.tableCell}
                  >
                    {gross_margin ? gross_margin.data_two.value : 0}%
                    </Table.Cell>
                </Table.Row>

                <Table.Row style={styles.tablerow}>
                  <Table.Cell
                    verticalAlign="middle"
                    textAlign="left"
                    style={styles.tableCellfirst}
                  >
                    Tax Collected
                    </Table.Cell>


                  <Table.Cell
                    verticalAlign="middle"
                    className="totalSales"
                    style={styles.tableCell}
                  >
                    {net_taxes ? net_taxes.value : 0}
                  </Table.Cell>
                </Table.Row>

                <Table.Row style={styles.tablerow}>
                  <Table.Cell
                    verticalAlign="middle"
                    textAlign="left"
                    style={styles.tableCellfirst}
                  >
                    Tips
                    </Table.Cell>

                  <Table.Cell
                    verticalAlign="middle"
                    className="totalSales"
                    style={styles.tableCell}
                  >
                    {tips ? tips.value : 0}
                  </Table.Cell>
                </Table.Row>

                <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Service charge
                    </Table.Cell>

                    
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {service_charges.value}
                    </Table.Cell>
                  </Table.Row>

                <Table.Row style={styles.tablerow}>
                  <Table.Cell
                    verticalAlign="middle"
                    textAlign="left"
                    style={styles.tableCellfirst}
                  >
                    Delivery charges
                    </Table.Cell>


                  <Table.Cell
                    verticalAlign="middle"
                    className="totalSales"
                    style={styles.tableCell}
                  >
                    {delivery ? delivery.value : 0}
                  </Table.Cell>
                </Table.Row>

                <Table.Row style={styles.tablerow}>
                  <Table.Cell
                    verticalAlign="middle"
                    textAlign="left"
                    style={styles.tableCellfirst}
                  >
                    Total Collected
                    </Table.Cell>

                  <Table.Cell
                    verticalAlign="middle"
                    className="totalSales"
                    style={styles.tableCell}
                  >
                    {total_collected ? total_collected.value : 0}
                  </Table.Cell>
                </Table.Row>

                <Table.Row style={styles.tablerow}>
                  <Table.Cell
                    verticalAlign="middle"
                    textAlign="left"
                    style={styles.tableCellfirst}
                  >
                    Voids # / Rs
                    </Table.Cell>

                  <Table.Cell
                    verticalAlign="middle"
                    className="totalSales"
                    style={styles.tableCell}
                  >
                    {void_number ? void_number.value : 0}{" "} |{" "}
                    {this.props.void ? this.props.void.value : 0}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Grid>











          {tabs ? (
            <Grid columns={1}>
              <Table
                className="mainTable alignment"
                fixed
                style={styles.mainTable}
              >
                <Table.Header>
                  <Table.Row style={styles.headerRow}>
                    <Table.HeaderCell textAlign="left" style={styles.hederCell}>
                      Sales Summary
                    </Table.HeaderCell>
                    {tabs.map((tab, index) => (
                      <Table.HeaderCell key={index} style={styles.hederCell}>
                        {tab.label}
                      </Table.HeaderCell>
                    ))}
                    <Table.HeaderCell style={styles.hederCell}>
                      TOTAL
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Gross Sales
                    </Table.Cell>

                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].gross_sales
                          ? this.props[tab.key].gross_sales.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {gross_sales ? gross_sales.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Discount & Comps
                    </Table.Cell>

                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].discounts
                          ? this.props[tab.key].discounts.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {discounts ? discounts.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Total Revenue
                    </Table.Cell>
                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].net_sales
                          ? this.props[tab.key].net_sales.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {net_sales.value}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      COGS
                    </Table.Cell>

                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].total_cogs
                          ? this.props[tab.key].total_cogs.value
                          : 0}
                      </Table.Cell>
                    ))}

                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {total_cogs ? total_cogs.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Margin By Rs
                    </Table.Cell>
                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        Rs.{" "}
                        {this.props[tab.key].gross_margin
                          ? this.props[tab.key].gross_margin.data_one.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      Rs. {gross_margin ? gross_margin.data_one.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Margin By %
                    </Table.Cell>

                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].gross_margin
                          ? this.props[tab.key].gross_margin.data_two.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {gross_margin ? gross_margin.data_two.value : 0}%
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Tax Collected
                    </Table.Cell>

                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].net_taxes
                          ? this.props[tab.key].net_taxes.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {net_taxes ? net_taxes.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Tips
                    </Table.Cell>
                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].tips
                          ? this.props[tab.key].tips.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {tips ? tips.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Service charge
                    </Table.Cell>


                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {service_charges.value}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Delivery charges
                    </Table.Cell>
                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].delivery
                          ? this.props[tab.key].delivery.value
                          : 0}
                      </Table.Cell>
                    ))}

                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {delivery ? delivery.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Total Collected
                    </Table.Cell>
                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].total_collected
                          ? this.props[tab.key].total_collected.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {total_collected ? total_collected.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Voids # / Rs
                    </Table.Cell>
                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].void_number
                          ? this.props[tab.key].void_number.value
                          : 0}{" "}
                        |{" "}
                        {this.props[tab.key].void
                          ? this.props[tab.key].void.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {void_number ? void_number.value : 0}|{" "}
                      {this.props.void ? this.props.void.value : 0}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Grid>
          ) : null}

          <Grid columns={2}>
            <Chart title="VOIDS" data={voidByDay} />
            <Chart title="REFUNDS" data={refundByDay} />
            {/* <Chart title="PAYMENT METHOD" data={paymentMethod} /> */}
          </Grid>
          <Grid columns={2}>
            <TableData
              style={{ marginLeft: -25 }}
              currency="Rs."
              componentData={top_items_by_sales}
            />
            <TableData currency="Rs." componentData={lowest_items_by_sales} />
          </Grid>
        </div>
      </div>
    );
  }
}

const styles = {
  headingText: {
    fontSize: 16,
    color: "#666874",
    marginTop: 20,
    marginBottom: 15,
    paddingBottom: 18,
    paddingLeft: 5,
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto",
    textShadow: "none",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "#c1c1c5"
  },
  comingSoon: {
    backgroundColor: "#59d345",
    color: "#fff",
    fontFamily: "Roboto",
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 15,
    paddingRight: 15
  },
  dropDown: {
    fontFamily: "Roboto",
    borderRadius: 20,
    color: "rgb(102, 104, 116)",
    marginRight: 50,
    position: "relative",
    top: 52,
    backgroundColor: "transparent",
    fontSize: 14,
    fontWeight: 300
  },
  customClass: {
    backgroundColor: "transparent",
    color: "rgb(102, 104, 116)",
    fontSize: 14,
    fontWeight: 300
  },
  topHeader: {
    backgroundColor: "#652d92",
    color: "white"
  },
  mainHeadig: {
    marginTop: 30,
    fontWeight: 400,
    fontFamily: "Roboto",
    color: "#666874"
  },
  title: {
    padding: 10,
    fontSize: 22
  },
  sideBar: {
    top: 45,
    backgroundColor: "#2c2435"
  },
  datePicker: {
    paddingTop: 20,
    paddingRight: 20,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 400
  },

  mainTable: {
    borderWidth: 0,
    paddingLeft: 15,
    paddingRight: 15,
    backgroundColor: "transparent"
  },
  tablerow: {
    textAlign: "center",
    fontFamily: "Roboto",
    backgroundColor: "none"
  },
  hederCell: {
    backgroundColor: "#ECF3FA",
    color: "#999",
    fontSize: 14,
    fontWeight: 300,
    paddingTop: 15,
    paddingBottom: 15,
    borderColor: "#c1c1c5",
    borderWidth: 0.7,
    borderRadius: 0
  },
  tableCellfirst: {
    backgroundColor: "#F9F9FE",
    color: "#999",
    fontSize: 14,
    paddingTop: 15,
    paddingBottom: 15,
    borderTopWidth: 0.5,
    borderTopColor: "#C9C9C9"
  },
  tableCell: {
    backgroundColor: "#F9F9FE",
    color: "#313131",
    fontSize: 14,
    paddingTop: 25,
    paddingBottom: 25,
    borderTopWidth: 0.5,
    borderTopColor: "#C9C9C9"
  },
  headerRow: {
    textAlign: "center",
    fontFamily: "Roboto"
  },
  heading: {
    fontSize: 16,
    color: "rgb(102, 104, 116)",
    paddingBottom: 10,
    paddingLeft: 15,
    paddingTop: 5,
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto"
  }
};

export default connect(state => {
  return {
    ...state.analytics
  }
})(KE_Data);



// WEBPACK FOOTER //
// ./src/components/Tabs/ke_data.js